import {
  Text,
  Field,
  ImageField,
  Image,
  LinkField,
  Item,
  getFieldValue,
  ComponentRendering,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import Link, { LinkVariant } from 'components/helpers/Link/Link';
import { ButtonVariant } from 'components/helpers/Button/Button';
import { RecordOfFields } from 'models/fields';

import styles from './Listings.module.scss';

const cx = classNames.bind(styles);

type ToutListingCardProps = {
  fields: ToutCardFields;
  rendering?: ComponentRendering;
};

export type ToutCardFields = {
  title: Field<string>;
  titleTextStyle: Item | null;
  titleLevel: Item;
  image: ImageField;
  description: Field<string>;
  buttonLink: LinkField;
  buttonLinkText: Field<string>;
  buttonLinkMode: Item;
  arrowLink: LinkField;
  arrowLinkText: Field<string>;
};

const ToutListingCard = (props: ToutListingCardProps): React.JSX.Element => {
  const titleLvl = getFieldValue<string>(props.fields.titleLevel?.fields as RecordOfFields, 'Value') || 'h3';
  const { sitecoreContext } = useSitecoreContext();

  const btnMode = (props.fields.buttonLinkMode?.fields as RecordOfFields) || 'primary';
  const btnFieldValue = getFieldValue<ButtonVariant | LinkVariant>(btnMode, 'Value');
  const titleTextStyleItemField = props.fields.titleTextStyle?.fields as RecordOfFields;
  const textStyleValue = getFieldValue<string>(titleTextStyleItemField, 'Value') || 'font-style-xl';

  const arrowText: Field<string> = {
    value:
      props.fields.arrowLinkText.value != ''
        ? props.fields.arrowLinkText.value
        : props.fields.arrowLink.value.text ?? '',
  };

  const buttonText: Field<string> = {
    value:
      props.fields.buttonLinkText.value != ''
        ? props.fields.buttonLinkText.value
        : props.fields.buttonLink.value.text ?? '',
  };

  const card = (
    <>
      <Image class={styles['tout-card-container__image']} field={props.fields.image} />
      {props.fields.image.value?.src === undefined && <div></div>}

      <Text
        field={props.fields.title}
        className={cx({ [textStyleValue]: true })}
        tag={titleLvl}
        encode={sitecoreContext.pageEditing}
      />
      {props.fields.title.value === '' && <div></div>}

      <RichTextWrapper
        tag="div"
        field={props.fields.description}
        className={styles['tout-card-container__description']}
      />
      {props.fields.description.value === '' && <div></div>}

      {props.fields.buttonLink?.value.href !== '' && (
        <div className={styles['button']}>
          <Link
            className={btnFieldValue}
            field={props.fields.buttonLink}
            variant={btnFieldValue}
            showLinkTextWithChildrenPresent={false}
          >
            <Text field={buttonText} encode={sitecoreContext.pageEditing} />
          </Link>
        </div>
      )}
      {props.fields.buttonLink?.value.href === '' && <div></div>}

      {props.fields.arrowLink?.value.href !== '' && (
        <Link
          field={props.fields.arrowLink}
          className={styles['tout-card-container__arrowLink']}
          icon="carat"
          showLinkTextWithChildrenPresent={false}
        >
          <Text field={arrowText} encode={sitecoreContext.pageEditing} />
        </Link>
      )}
      {props.fields.arrowLink?.value.href === '' && <div></div>}
    </>
  );

  if (props.rendering) {
    return <div className={cx({ 'd-grid': true })}>{card}</div>;
  }

  return card;
};

export default ToutListingCard;
